// UI-C16 NameVoiceSheet (MAJLIS-65; D-18, P-16, DM-9): the prototype's #voicesheet. The shared seat's holder, or a
// host, taps a voice's label and types who is speaking; "Name" sends name_voice. Nothing changes here on the tap:
// voice_named is what relabels every bubble of that voice (never optimistic), for this reader and every other.
import { useState, type FormEvent } from "react";
import { VOICE_NAME_MAX } from "../constants";
import { useI18n } from "../i18n";
import { Sheet } from "./Sheet";

export function NameVoiceSheet({
  label,
  current,
  onName,
  onClose,
}: {
  /** The voice's label as the bubbles show it now ('<seat> · voice n', or its name). */
  label: string;
  /** Its current name ("" while unnamed): the field starts from it, as the prototype's does. */
  current: string;
  onName: (name: string) => void;
  onClose: () => void;
}) {
  const { t } = useI18n();
  const [value, setValue] = useState(current);
  const name = value.trim();
  const submit = (e: FormEvent) => {
    e.preventDefault();
    if (!name) return; // the server trims too, and refuses an empty name; never send one
    onName(name);
    onClose();
  };
  return (
    <Sheet title={t("nameVoiceTitle", { label })} onClose={onClose} spec="UI-C16 P-16 D-18">
      <form className="voice-sheet" id="voicesheet" onSubmit={submit}>
        <input
          className="text-input"
          id="voicename"
          dir="auto"
          value={value}
          maxLength={VOICE_NAME_MAX}
          placeholder={t("nameVoicePlaceholder")}
          aria-label={t("nameVoiceField")}
          autoComplete="off"
          onChange={(e) => setValue(e.target.value)}
        />
        <div className="voice-sheet-actions">
          <button type="button" className="text-link" id="voicecancel" onClick={onClose}>
            {t("cancel")}
          </button>
          <button type="submit" className="primary" id="voicesave" disabled={!name || name === current}>
            {t("nameVoiceSave")}
          </button>
        </div>
      </form>
    </Sheet>
  );
}
